namespace GeniuzPOS.Member {
    export interface MbReport02_Form {
        MbCardStatus: Serenity.RadioButtonEditor;
        MbType: Serenity.StringEditor;
        MbCardType: Serenity.StringEditor;
        MbApplyDate: Serenity.DateEditor;
        MbExpireDate: Serenity.DateEditor;
        MbAccumPoint: Serenity.DecimalEditor;
        MbNearlyExpirePoint: Serenity.DecimalEditor;
        MbExpirePointDate: Serenity.DateEditor;
        MbId: Serenity.StringEditor;
        MbNameT: Serenity.StringEditor;
        MbNameE: Serenity.StringEditor;
        MbNation: Serenity.StringEditor;
        MbRace: Serenity.StringEditor;
        MbBirthDay: Serenity.DateEditor;
        MbPid: Serenity.StringEditor;
        MbGender: Serenity.LookupEditor;
        MbOccupation: Serenity.StringEditor;
        MbTelNo: Serenity.StringEditor;
        MbEmail: Serenity.StringEditor;
        MbPhoto: Serenity.ImageUploadEditor;
        MbMemo: Serenity.TextAreaEditor;
        MbAddress: Serenity.TextAreaEditor;
        MbTumbol: Serenity.LookupEditor;
        MbAmphur: Serenity.LookupEditor;
        MbProvince: Serenity.LookupEditor;
        MbZipCode: Serenity.StringEditor;
    }

    export class MbReport02_Form extends Serenity.PrefixedContext {
        static formKey = 'Member.MbReport02_';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!MbReport02_Form.init)  {
                MbReport02_Form.init = true;

                var s = Serenity;
                var w0 = s.RadioButtonEditor;
                var w1 = s.StringEditor;
                var w2 = s.DateEditor;
                var w3 = s.DecimalEditor;
                var w4 = s.LookupEditor;
                var w5 = s.ImageUploadEditor;
                var w6 = s.TextAreaEditor;

                Q.initFormType(MbReport02_Form, [
                    'MbCardStatus', w0,
                    'MbType', w1,
                    'MbCardType', w1,
                    'MbApplyDate', w2,
                    'MbExpireDate', w2,
                    'MbAccumPoint', w3,
                    'MbNearlyExpirePoint', w3,
                    'MbExpirePointDate', w2,
                    'MbId', w1,
                    'MbNameT', w1,
                    'MbNameE', w1,
                    'MbNation', w1,
                    'MbRace', w1,
                    'MbBirthDay', w2,
                    'MbPid', w1,
                    'MbGender', w4,
                    'MbOccupation', w1,
                    'MbTelNo', w1,
                    'MbEmail', w1,
                    'MbPhoto', w5,
                    'MbMemo', w6,
                    'MbAddress', w6,
                    'MbTumbol', w4,
                    'MbAmphur', w4,
                    'MbProvince', w4,
                    'MbZipCode', w1
                ]);
            }
        }
    }
}
